import service from '@/store/services/year-service';

const state = {
  list: {},
  year: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, year) => {
    state.year = year;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service
      .list(params)
      .then((list) => {
        if (list.hasOwnProperty('data') && list.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              list.data.errorCode,
            { root: true }
          );
        }
        commit('SET_LIST', list);
        return list;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },

  get({ commit, dispatch }, params) {
    return service
      .get(params)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        commit('SET_RESOURCE', res.data.year);
        return year;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },

  add({ commit, dispatch }, params) {
    return service
      .add(params)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        commit('SET_RESOURCE', res.data.year);
        return res.data.year;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },

  update({ commit, dispatch }, params) {
    return service
      .update(params)
      .then((year) => {
        if (year.hasOwnProperty('data') && year.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              year.data.errorCode,
            { root: true }
          );
        }
        commit('SET_RESOURCE', year);
        return year;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  year: (state) => state.year,
};

const year = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default year;
